/**
 * Created by ronak-jain on 10/10/18.
 */

const english = {
  product: 'Product',
  contact_us: 'Contact Us',
  about_us: 'About Us',
  reasons_to_choose: 'Reasons to choose us',
  tagline1: 'Tailor-made flexible loans',
  tagline2: 'Loans to grow businesses with uneven cashflows',
  apply: 'Apply',
  submit: 'Submit',
  flexible_terms: 'Flexible Terms',
  custom_loan: 'Custom Loans with flexible repayment terms',
  quick_disbursement: 'Quick disbursement',
  receive_loan: 'Receive your loan within 3 days',
  paper_work: 'Minimum / No paper work',
  paper_docs: 'No more carrying paper docs',
  customer_focused: 'Customer focused',
  customer_service: 'Friendly and respectful customer service',
  data_security: 'Data security',
  secured_ssl: 'Your information is secured behind SSL',
  how_it_works: 'How it works',
  send_enquiry: 'Send Enquiry',
  online_application: 'Call us or fill a small application form online',
  quick_verification: 'Quick Verification',
  quick_ekyc: 'Undergo a quick eKYC',
  upload_documents: 'Upload Scanned Documents',
  scan_documents: 'Our representative will scan your documents',
  loan_sanction: 'Loan Sanction',
  loan_approval: 'Fast loan approval',
  application_form: 'Application Form',
  name: 'Name',
  mobile: 'Mobile',
  loan_amount: 'Loan Amount Required (in lacs)',
  address: 'Area Of Residence',
  go_back: "Go Back",
  for_assistance: "For Assistance",
  call: "Call",
  email: "Email",
  company: "Company",
  team: "Team",
  lap: "Loan Against Property",
  help: "Help",
  privacy_policy: "Privacy Policy",
  product_page_img_text:"Customized products for various requirements",
  product_page_title: "Customized loans to fund your credit requirements",
  product_page_subtitle:"Whether you're looking to refurbish your property, buy an asset or you just need cash for working capital, we want to help you and your business succeed. At Ascend Capital, we understand the different cash flow and credit requirements of merchants, retailers, suppliers, manufacturers, travel agents, radio cab drivers and small business owners. Therefore, we have created customized loans that take into account short and long-term investment requirements, loan tenures and SME-friendly repayment terms. Browse through our loan portfolio and choose the credit product that best suits your business requirements.",
  product_page_features:"Features",
  product_page_feature1:"Customized credit criteria - Credit underwriting parameters take stock of the nature of your business, scale of operations and revenue to create a unique offer.",
  product_page_feature2:"Easy, convenient and quick application process - Call us or you just need 10 minutes and a mobile, laptop or tablet to apply for a business loan. Once you submit the application, our representative will visit your office to collect the necessary KYC documents. We typically process all applications within 7 days from submission, and immediately transfer the funds to your account.",
  product_page_feature3:"Quick disbursal - Our cutting-edge tech-integration and data-driven competencies allow quick assessment of creditworthiness and disbursal of working capital finance.",
  product_page_feature4:"Flexible repayment terms - Manage cash flows efficiently and cover the gaps in working capital expenditures with our easy and flexible repayment terms.",
  product_page_feature5:"Loan tenures as per requirement - You can opt for short term as well as long term business loans, depending upon your business resources and objectives.",
  mortgage_loan:"Mortgage loan",
  product_page_loan1:"Loan Amount - ₹ 3 lacs to 20 lacs repayment",
  product_page_loan2:"Tenure - 1 year to 7 years",
  product_page_loan3:"Interest rate - 21% to 25% per annum Secured against mortgage over marketable security",
  product_page_loan4:"Processing fee - 3% + GST",
  product_page_loan_requirements:"Requirements",
  product_page_requirements1:"Continuity in business - Min. 3 years in the same line of business",
  product_page_requirements2:"Residence & office stability for 3 years",
  product_page_requirements3:"Financial documents – Last 6 months bank statements. If you don’t have ITR’s then our team will work with you for variety of documentation alternatives",
  vehicle_loan: 'Vehicle Loan',
  vehicle_loan_desc1:"Loan Amount - ₹ 50,000 to 20 lacs repayment",
  vehicle_loan_desc2:"Tenure - 1 year to 7 years",
  vehicle_loan_desc3:"Interest rate - 21% to 25% per annum secured against hypothecated vehicle",
  vehicle_loan_desc4:"Processing fee - 2% + GST",
}

export default english


// WEBPACK FOOTER //
// ./src/constants/english.js